export default __webpack_public_path__ + "static/media/WaterClarityChange.87175862.png";